export interface Category {
  name: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=a%20pair%20of%20clean%20white%20and%20beige%20sneakers%20placed%20on%20a%20light%20concrete%20block%20against%20a%20soft%20neutral%20studio%20wall%20with%20gentle%20daylight%20product%20photography&width=400&height=300&seq=cat-shoes-01&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=a%20folded%20cozy%20sage%20green%20hoodie%20neatly%20displayed%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20wall%20with%20soft%20diffused%20lighting%20fashion%20product%20photo&width=400&height=300&seq=cat-hoodies-01&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=two%20folded%20plain%20cotton%20t%20shirts%20in%20white%20and%20charcoal%20stacked%20on%20a%20light%20linen%20surface%20with%20soft%20natural%20shadows%20minimal%20apparel%20photography&width=400&height=300&seq=cat-tshirts-01&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-user-3-line',
    image: 'https://readdy.ai/api/search-image?query=a%20stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20wooden%20rack%20against%20a%20clean%20beige%20studio%20backdrop%20with%20soft%20warm%20lighting%20product%20photography&width=400&height=300&seq=cat-jackets-01&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-scissors-line',
    image: 'https://readdy.ai/api/search-image?query=a%20folded%20pair%20of%20light%20blue%20denim%20jeans%20and%20beige%20cargo%20shorts%20arranged%20on%20a%20white%20table%20with%20soft%20natural%20light%20and%20a%20minimal%20clean%20background&width=400&height=300&seq=cat-pants-01&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=a%20neutral%20toned%20baseball%20cap%20and%20a%20beanie%20placed%20side%20by%20side%20on%20a%20light%20grey%20surface%20with%20soft%20studio%20lighting%20and%20a%20clean%20minimal%20backdrop&width=400&height=300&seq=cat-headwear-01&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=a%20matching%20two%20piece%20coordinated%20outfit%20set%20laid%20flat%20with%20a%20hoodie%20and%20sweatpants%20on%20a%20warm%20beige%20background%20soft%20natural%20light%20fashion%20photography&width=400&height=300&seq=cat-sets-01&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-t-shirt-2-line',
    image: 'https://readdy.ai/api/search-image?query=neatly%20folded%20cotton%20underwear%20and%20undershirts%20in%20soft%20neutral%20colors%20arranged%20on%20a%20clean%20white%20surface%20with%20gentle%20lighting%20minimal%20apparel%20photo&width=400&height=300&seq=cat-underwear-01&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=a%20sporty%20athletic%20jersey%20with%20a%20number%20on%20the%20front%20hanging%20on%20a%20rack%20against%20a%20clean%20bright%20studio%20wall%20with%20soft%20even%20lighting%20sports%20product%20photo&width=400&height=300&seq=cat-jersey-01&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=a%20tidy%20arrangement%20of%20sunglasses%20a%20watch%20and%20a%20small%20wallet%20on%20a%20light%20marble%20surface%20with%20soft%20shadows%20and%20a%20clean%20minimal%20background&width=400&height=300&seq=cat-accessories-01&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=a%20minimalist%20tan%20leather%20tote%20bag%20and%20a%20small%20black%20crossbody%20bag%20placed%20on%20a%20white%20shelf%20with%20soft%20natural%20light%20product%20photography&width=400&height=300&seq=cat-bags-01&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/category-922-Belts.html',
    icon: 'ri-scissors-cut-line',
    image: 'https://readdy.ai/api/search-image?query=two%20rolled%20leather%20belts%20in%20brown%20and%20black%20arranged%20neatly%20on%20a%20light%20wooden%20surface%20with%20soft%20warm%20lighting%20and%20a%20clean%20neutral%20background&width=400&height=300&seq=cat-belts-01&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/category-923-Perfumes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=an%20elegant%20glass%20perfume%20bottle%20with%20a%20minimal%20label%20on%20a%20clean%20white%20podium%20with%20soft%20diffused%20light%20and%20gentle%20reflections%20luxury%20product%20photo&width=400&height=300&seq=cat-perfumes-01&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/category-924-Other%20Stuff.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=a%20curated%20assortment%20of%20small%20lifestyle%20items%20including%20a%20keychain%20a%20notebook%20and%20a%20phone%20case%20on%20a%20light%20neutral%20table%20soft%20natural%20light%20minimal%20flat%20lay&width=400&height=300&seq=cat-other-01&orientation=landscape',
  },
];